
import { Component, Vue, Watch } from 'vue-property-decorator'

import BacAlert from '@/components/BacAlert.vue'
import BacEditableMinioImage from '@/components/BacEditableMinioImage.vue'
import BacInput from '@/components/BacInput.vue'
import BacTextarea from '@/components/BacTextarea.vue'
import BacButton from '@/components/BacButton.vue'
import { CustomerRegister } from '../lib/models/CustomerRegister'
import { RallyRound } from '../lib/models/RallyRound'
import { Http } from '../lib/utils/Http'
import UIkit from 'uikit'
import { MinioRessource } from '../lib/models/MinioRessource'
import { ISaveResponse } from '../lib/dtos/ISaveResponse'

@Component({
  components: {
    BacAlert,
    BacEditableMinioImage,
    BacInput,
    BacTextarea,
    BacButton
  }
})
export default class RegisterGuide extends Vue {
  customerRegister: CustomerRegister = new CustomerRegister()
  rallyRound: RallyRound = new RallyRound()
  startNumbers = []
  startNumber = -1
  name = ''
  description = ''

  teamLogo: MinioRessource = new MinioRessource()
  rallyRoundDefaultTeamLogo: MinioRessource = new MinioRessource()

  get teamLogoPath () {
    if (this.teamLogo && this.teamLogo.path) {
      return this.teamLogo.path
    }
    if (this.rallyRoundDefaultTeamLogo.path) {
      return this.rallyRoundDefaultTeamLogo.path
    }
    return ''
  }

  mounted () {
    this.loadData()
  }

  @Watch('rallyRound')
  async loadDefaultTeamLogo () {
    if (this.rallyRound.defaultTeamLogoId) {
      this.teamLogo = await MinioRessource.get(this.rallyRound.defaultTeamLogoId)
    }
  }

  async teamLogoSaved (data: ISaveResponse) {
    this.teamLogo = await MinioRessource.get(data.id)
  }

  async teamLogoDelete () {
    this.loadDefaultTeamLogo()
  }

  async loadData () {
    this.customerRegister = await CustomerRegister.get(this.$route.params.cuid)
    this.startNumber = this.customerRegister.teamnumber ?? -1
    this.name = this.customerRegister.teamname ?? ''
    this.description = this.customerRegister.teamdescription ?? ''

    if (this.customerRegister.rallyRoundId) {
      this.rallyRound = await RallyRound.get(this.customerRegister.rallyRoundId)
    } else {
      console.error('rally round id in register guide equals false, this should never happen!')
    }
    // this.logoPath = (await import(`@/assets/img/rally/rounds/logos/${this.rallyRound.logo}`)).default

    const startNumbers = await Http.request('/api/team-number')
    this.startNumbers = await startNumbers.json()
  }

  validateInput (): string | null {
    if (!this.name) {
      return 'Bitte gib einen Teamnamen an!'
    }
    /* if (this.startNumber <= 0) {
      return 'Bitte wähle eine Startnummer aus!'
    } */
    return null
  }

  async save () {
    const error = this.validateInput()
    if (error) {
      UIkit.notification({
        message: error,
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      return
    }
    const res = await Http.request('/api/team-number', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        customerRegisterId: this.customerRegister.id,
        name: this.name,
        description: this.description,
        startNumber: this.startNumber,
        logoId: this.teamLogo.id
      })
    })
    if (res.status === 200) {
      this.$router.push(`/register-state/${this.customerRegister.id}`)
    } else {
      UIkit.notification({
        message: 'Die Startnummer wurde bereits vergeben, bitte aktualisiere die Seite und versuche es erneut!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
    }
    this.loadData()
  }
}
